import { createContext } from 'react';

const VoicesBlogsContext = createContext([]);
export default VoicesBlogsContext;
